<!--
Author: TangChen
Date: 2018-12-08
Desc: 基金赎回，由index.js 配置引入
-->
<template>
    <div>
        <div class="bor_E4E4E4">
            <comp-title :title="title">
                <el-breadcrumb separator-class="el-icon-arrow-right">
                    <el-breadcrumb-item :to="{ path: '/home' }">我的资产</el-breadcrumb-item>
                    <el-breadcrumb-item>{{ title }}</el-breadcrumb-item>
                </el-breadcrumb>
            </comp-title>
            <el-form
                v-show="!buySuccess"
                ref="fundInfo"
                :model="fundInfo"
                :rules="rules"
                label-width="260px"
                class="pwdForm"
                inline-message
                v-on:submit.native.prevent
            >
                <el-form-item label="基金名称：" class="form-text">
                    <div class="text-con">
                        {{ fund.fundname + "(" + fund.fundcode + ")" }}
                    </div>
                </el-form-item>
                <el-form-item label="收费方式：" prop="sharetype" class="form-text">
                    <el-select v-model="fundInfo.sharetype" :disabled="fund.sharetype !== '2'">
                        <el-option value="0" label="前收费"></el-option>
                        <el-option value="1" label="后收费"></el-option>
                    </el-select>
                    <el-tooltip placement="top">
                        <div slot="content">
                            前收费是在申购基金时收取申购费,
                            <br />
                            而后收费则是在申购时不收费，
                            <br />
                            在赎回时才收取手续费用。
                        </div>
                        <img src="../../assets/img/tip.png" class="w18 h18 ml12" />
                    </el-tooltip>
                </el-form-item>
                <el-form-item label="赎回到：" prop="sellTo" class="payway-list">
                    <div class="flex lin20">
                        <div
                            v-if="
                                $util.xjbIsOpen() &&
                                $util.sellToXjbOpen() &&
                                hasxjb &&
                                xjbfundcode !== fund.fundcode &&
                                !isOffline &&
                                !mrfflag &&
                                xjbSellflag
                            "
                            class="bor_D9D9D9 br_8 pl10 pr15 pt16 pb44 mr20 relative pointer"
                            v-on:click="fundInfo.sellTo = '1'"
                        >
                            <div class="fs18 c_333 mb10 center">
                                {{ $const.getXJBParam("name") }}
                            </div>
                            <div class="c_999 fs14">
                                最新七日年化收益率:{{
                                    $util.isEmpty(growthrate) ? "--" : $util.fmtNum(growthrate, 4)
                                }}%。
                            </div>
                            <div class="c_999 fs14">买基金立享优惠</div>
                            <img
                                src="../../assets/img/recommend.png"
                                class="absolute w65 h65 _t2 _r2"
                            />
                            <div
                                v-if="fundInfo.sellTo === '1'"
                                class="bc_E60012 h30 w100x br-b-7 absolute l0 b0 flex wcenter hcenter"
                            >
                                <img
                                    src="../../assets/img/square-checked-white.png"
                                    class="w16 h12"
                                />
                            </div>
                        </div>
                        <div
                            class="bor_D9D9D9 br_8 pl10 pr15 pt16 pb44 relative pointer"
                            style="min-width: 120px"
                            v-on:click="fundInfo.sellTo = '2'"
                        >
                            <div class="fs18 c_333 mb10 center">银行卡</div>
                            <div
                                v-if="$util.getFundTrans('showselltobankcarddesc')"
                                class="c_999 fs14"
                            >
                                银行活期存款利率：0.35%。
                            </div>
                            <div
                                v-if="$util.getFundTrans('showselltobankcarddesc')"
                                class="c_999 fs14"
                            >
                                若不急需现金，建议转至{{ $const.getXJBParam("sname") }}
                            </div>
                            <div
                                v-if="fundInfo.sellTo === '2'"
                                class="bc_E60012 h30 w100x br-b-7 absolute l0 b0 flex wcenter hcenter"
                            >
                                <img
                                    src="../../assets/img/square-checked-white.png"
                                    class="w16 h12"
                                />
                            </div>
                        </div>
                    </div>
                </el-form-item>
                <el-form-item label="回款账号：" prop="id" class="payway-list">
                    <el-radio-group v-model="fundInfo.id" class="bank-radio">
                        <el-radio
                            v-for="bank in fundInfo.sellTo == '1'
                                ? fund.fundArr.filter((item) => item.sellmode.includes('1'))
                                : fund.fundArr"
                            :key="bank.transactionaccountid + bank.index"
                            :label="bank.transactionaccountid + bank.index"
                            border
                        >
                            <div class="bank-img-sel">
                                <img
                                    v-if="bank.bankcode"
                                    :src="$util.getImg(bank.bankcode)"
                                    alt=""
                                />
                                <div class="k-text-flow">
                                    <span
                                        class="bank-name"
                                        :title="$cache.getDict('110080', bank.bankcode)"
                                    >
                                        {{
                                            $cache.getDict("110079", bank.paycenterid) +
                                            "-" +
                                            $cache.getDict("110080", bank.bankcode)
                                        }}{{
                                            bank.depositcard
                                                ? "（" + bank.depositcard.substr(-7, 7) + "）"
                                                : ""
                                        }}
                                    </span>
                                    总额(份)：
                                    <span class="bank-balance">
                                        {{ $util.fmtNum(bank.usableremainshare) }}
                                    </span>
                                </div>
                                <i class="el-icon-check" aria-hidden="true" />
                            </div>
                        </el-radio>
                    </el-radio-group>
                    <div v-if="sourceflagAllotment" class="sourceflag-tip">
                        <span class="allotment">
                            存在不可赎回的代销渠道份额共{{ $util.fmtNum(sourceflagAllotment) }}份。
                        </span>
                        <span class="toDetails" v-on:click.stop="showDetail">点击查看详情>>></span>
                    </div>
                </el-form-item>
                <el-form-item label="可用份额：" class="form-text red">
                    <div class="text-con">
                        {{ $util.fmtNum(bankInfo.usableremainshare) + "份" }}
                        <span class="freeze">
                            (冻结份额：{{ $util.fmtNum(bankInfo.freezeremainshare) }}份)
                        </span>
                    </div>
                </el-form-item>
                <el-form-item
                    label="赎回份额："
                    prop="amount"
                    class="redemp-amount"
                    :class="{ 'form-text': !isPwdCheck && fundInfo.sellTo === '1' }"
                >
                    <el-input
                        v-model.trim="fundInfo.amount"
                        class="prefix"
                        :placeholder="pla"
                        :maxlength="14"
                    />
                    <span v-if="!isAmountAll" class="redemp-btn" v-on:click.prevent="allSell">
                        <span class="like-a">全部赎回</span>
                    </span>
                </el-form-item>
                <el-form-item v-if="Number(fundInfo.amount)" label="份额确认：">
                    {{ $util.capitalShare(fundInfo.amount, "份") }}
                </el-form-item>
                <el-form-item v-if="fund.fundtype !== '2'" label="巨额赎回处理：">
                    <el-select
                        v-model="fundInfo.largeredemptionflag"
                        :disabled="fundInfo.sellTo === '1'"
                    >
                        <el-option label="放弃超额部分" value="0" />
                        <el-option label="继续赎回" value="1" />
                    </el-select>
                    <el-tooltip placement="top">
                        <div slot="content">
                            单个开放日中，如果一只基金的净赎回申请超过该基金上一日基金总份额的10％时，即认为该基金发生了巨额赎回。
                            <br />
                            如果遇到巨额赎回，则提交的赎回份额会按一定比例赎回。
                            <br />
                            如果选择“放弃超额部分”则放弃赎回剩余部分。
                            <br />
                            如果选择“继续赎回”则剩余部分会作为下一工作日的赎回申请继续赎回。
                        </div>
                        <img src="../../assets/img/tip.png" class="w18 h18 ml12" />
                    </el-tooltip>
                </el-form-item>
                <el-form-item
                    v-if="
                        fundInfo.sellTo === '2' &&
                        redeemInfo.selltype &&
                        redeemInfo.selltype.indexOf('1') > -1
                    "
                    label="赎回方式："
                    prop="sell"
                    class="payway-list"
                >
                    <el-radio-group v-model="fundInfo.sell">
                        <el-radio label="0" name="sell">普通赎回</el-radio>
                        <el-radio label="1" name="sell">
                            快速赎回
                            <span>(预计2小时到账，不享受当天收益)</span>
                        </el-radio>
                    </el-radio-group>
                </el-form-item>

                <el-form-item
                    v-show="
                        (feeGate.executionrate || feeGate.executionrate === 0) &&
                        fund.fundshowtype !== '5'
                    "
                    label="赎回费率："
                    class="form-text"
                >
                    <div v-if="rateMax && rateMin">
                        <span>{{ rateMin + "~" + rateMax }}</span>
                        <img
                            v-if="fundFeeRate.length > 0 && fundFeeRate[0].feepolicy == '2'"
                            src="../../assets/img/tip-gray.png"
                            class="w18 h18"
                            style="vertical-align: middle; cursor: pointer"
                            v-on:click="
                                () => {
                                    feeRateVisible = true;
                                }
                            "
                        />
                        <span v-if="fundFeeRate[0].feepolicy == '2'" class="text-gray">
                            （若持有时间小于7日，将收取不低于1.50%的赎回手续费）
                        </span>
                    </div>
                    <div v-else>
                        {{ $util.fmtToPercent(feeGate.executionrate) }}
                    </div>
                </el-form-item>
                <el-form-item
                    v-show="
                        fund.fundshowtype !== '5' &&
                        (feeGate.estimatedcost || feeGate.estimatedcost === 0)
                    "
                    label="预估赎回手续费："
                    class="form-text"
                >
                    <div>
                        <span style="color: var(--color-primary)">
                            {{ $util.fmtNum(feeGate.estimatedcost) }}元
                        </span>
                        <span class="text-gray left-5">(仅为预计金额，以基金公司确认为准)</span>
                    </div>
                </el-form-item>
                <el-form-item v-if="$util.hasFM(fund)">
                    <div>
                        <span style="color: var(--color-primary)">
                            该产品为浮动管理费产品，存在扣除超额管理费或返还或有管理费的可能，具体金额以实际到账为准。您可通过交易确认查询。
                        </span>
                    </div>
                </el-form-item>
                <el-form-item v-if="isPwdCheck" label="交易密码：" prop="pwd">
                    <el-input
                        v-model.trim="fundInfo.pwd"
                        type="password"
                        placeholder="请输入交易密码"
                        :maxlength="20"
                    />
                    <!--                <span class="redemp-btn" v-on:click.prevent="$router.push({name: 'tradepwd'})"><span class="like-a">忘记密码？</span></span>-->
                </el-form-item>
                <el-form-item v-if="fundInfo.sell == '1'" style="margin-left: -80px">
                    <div
                        v-if="protocolArr.length !== 0"
                        class="check-box bar-pad showChenckbox"
                        style="font-size: 14px; display: flex; align-items: flex-start"
                    >
                        <div style="display: flex; align-items: center">
                            <input v-model="checkbox" type="checkbox" />
                            <span style="padding-left: 5px; color: var(--color-text-primary)">
                                我已阅读并同意:
                            </span>
                        </div>
                        <ul>
                            <li v-for="(item, index) in protocolArr" :key="index">
                                <a :href="$util.imgSrc({ fileCode: item.fileid })" target="_blank">
                                    《{{ item.title }}》
                                </a>
                            </li>
                        </ul>
                    </div>
                </el-form-item>
                <!-- <el-form-item
                    v-if="$util.getFundTrans('showpenaltyrate') && fund.fundshowtype !== '5'"
                >
                    <div>
                        <span class="c_E60012">
                            基金赎回会产生一定费用，若持有时间小于7日，将收取1.5%的赎回手续费。
                        </span>
                        <a v-if="linkUrl" target="_blank" :href="linkUrl">点击查看费率>>></a>
                    </div>
                </el-form-item> -->
                <el-form-item
                    v-if="(fundInfo.sellTo == '1' && tradeRestrictionsShow) || postChargeDescribe"
                >
                    <div
                        class="deadlinetime-content"
                        style="color: var(--color-text-accent); line-height: 20px"
                    >
                        <div>温馨提示：</div>
                        <div
                            v-if="fundInfo.sellTo == '1' && tradeRestrictionsShow"
                            style="display: flex; align-items: flex-start"
                        >
                            <span style="margin-right: 2px">1.</span>
                            <span class="c_E60012">
                                {{ $cache.getCompanyInfoParam("10102035") }}
                            </span>
                        </div>
                        <div
                            v-if="postChargeDescribe"
                            class="add-c_E60012"
                            style="display: flex; align-items: flex-start"
                        >
                            <span style="margin-right: 2px">
                                {{ fundInfo.sellTo == "1" && tradeRestrictionsShow ? "2." : "1." }}
                            </span>
                            <span>{{ postChargeDescribe }}</span>
                        </div>
                    </div>
                </el-form-item>
                <el-form-item>
                    <div style="width: 50%">
                        <el-button class="medium bc_E4E4E4 c_666666" v-on:click="$router.back()">
                            上一步
                        </el-button>
                        <el-button
                            type="primary"
                            class="medium"
                            :disabled="fundInfo.sell == '1' && !checkbox"
                            v-on:click="submitInfo('fundInfo')"
                        >
                            确定
                        </el-button>
                    </div>
                </el-form-item>
            </el-form>
            <result
                v-if="buySuccess"
                :result="result"
                v-on:return-page="goToTradeRecord"
                v-on:return-login="$router.push({ name: 'home' })"
            />
            <fund-protocol
                v-model="protocol"
                :fund="xjbFundRisk"
                :show-proto-arr="false"
                v-on:all-read="sellFund"
            />
        </div>
        <footerQuestions
            v-if="$const.warmReminderDisplay"
            :common-question="commonQuestion"
        ></footerQuestions>
        <buy-risk-dialog
            :visible.sync="buyRiskdialogVisible"
            :type="dialogType"
            :content="dialogContent"
            :button-text="dialogButtonText"
            v-on:confirm="handleDialogConfirm"
        />
        <my-dialog
            class="my-dialog-contain"
            title="费率"
            :visible="feeRateVisible"
            width="550px"
            :dialog-close="
                () => {
                    feeRateVisible = false;
                }
            "
        >
            <div class="dialog-box">
                <div class="">基金赎回手续费将按持有天数对应费率计算：</div>
                <el-table :data="fundFeeRate" class="rate-table" border>
                    <el-table-column prop="interval" label="持有期限" align="center" />
                    <el-table-column prop="feerate" label="费率" align="center" />
                </el-table>
                <div class="text-desc">
                    系统遵循先进先出原则；若赎回份额覆盖不同持有期限，将按分段费率分别计算后汇总。
                </div>
                <div style="text-align: center">
                    <el-button
                        class="btn"
                        v-on:click="
                            () => {
                                feeRateVisible = false;
                            }
                        "
                    >
                        确定
                    </el-button>
                </div>
            </div>
        </my-dialog>
    </div>
</template>
<script>
import mixin from "@/assets/js/mixin";
import result from "@/components/layout/result.vue";
import fundProtocol from "@/components/form/fundProtocol";
import fundApi from "@/api/fund";
import footerQuestions from "@/components/layout/footerQuestions.vue";
import format from "date-fns/format";
import buyRiskDialog from "@/components/fund/buyRiskDialog.vue";
import commonApi from "@/api/common";
import myDialog from "@/components/layout/myDialog.vue";

import { sceneEnum } from "@/util/util_jfit";
export default {
    name: "SellFund",
    components: {
        result,
        fundProtocol,
        footerQuestions,
        buyRiskDialog,
        myDialog
    },
    mixins: [mixin],
    data() {
        return {
            fundInfo: {
                amount: "",
                id: "",
                sell: "0",
                sharetype: "",
                sellTo: "",
                pwd: "",
                largeredemptionflag: "1"
            },
            protocol: false,
            isPwdCheck: false,
            isAmountAll: false,
            pla: "请先选择回款账号",
            fund: {}, // 基金信息获取
            sellLimit: {},
            buySuccess: false, // 购买状态
            result: {
                // 结果页面信息
                cla: "register-success",
                msg: "您的基金赎回申请已提交成功！",
                btnMsg: "预计确认时间：2018-11-16，如遇节假日则顺延，请耐心等待",
                special: false,
                btnL: {
                    text: "查看交易记录",
                    event: "return-page"
                },
                btnR: {
                    text: "返回我的资产",
                    event: "return-login"
                }
            },
            bankLists: [],
            xjbFundRisk: {}, // 现金宝适当性信息检查
            query: null,
            rules: {
                amount: [{ validator: this.amountLimit, trigger: "change" }],
                id: [{ required: true, message: "请选择回款账号", trigger: "change" }],
                pwd: [{ required: true, message: "请输入交易密码", trigger: "change" }],
                largeredemptionflag: [
                    { required: true, message: "请选择巨额赎回处理方式", trigger: "change" }
                ],
                sharetype: [{ required: true, message: "请选择收费方式", trigger: "change" }]
            },
            limit: { min: "0.01", max: "0", text: "赎回份额范围为：" },
            bankInfo: {},
            feeGate: {}, // 根据赎回份额查询的费率和费用信息
            fundFeeRate: [], // 根据基金代码查询赎回费率列表
            rateMax: "", // 最大费率值
            rateMin: "", // 最小费率值
            feeRateVisible: false, // 赎回费率展示
            hover: false,
            redeemInfo: {}, // 产品限额
            fastRedeemData: {}, // 快赎限额
            commonQuestion: [],
            xjbfundcode: "",
            growthrate: "", // 现金宝1七日年化
            hasxjb: false, // 是否可以赎回到钱柜
            isOffline: false,
            mrfflag: true, // 是否中港互认
            linkUrl: "",
            tradeRestrictionsShow: false, // 节假日xx宝的提示
            buyRiskdialogVisible: false, // 弹窗显示状态
            dialogType: "", // 弹窗类型（forbid/warn）
            dialogContent: "", // 弹窗文案
            dialogButtonText: "", // 按钮文案
            protocolArr: [],
            sellFiles: [],
            quickSellFiles: [],
            checkbox: false, // 阅读确认
            postChargeDescribe: "", // 附加管理费说明
            sourceflagAllotment: "", // 代销总份额
            xjbSellflag: true // 有赎回到现金宝的账号
        };
    },
    watch: {
        isOffline(val) {
            if (val) {
                this.$set(this.fundInfo, "sellTo", "2");
            }
        },
        "fundInfo.id"(val) {
            this.bankInfo = this.fund.fundArr.filter((item) => {
                return item.transactionaccountid + item.index === val;
            })[0];
            if (this.fundInfo.amount) {
                this.$refs.fundInfo.validateField("amount");
                this.queryRate();
            }
            this.queryFundlimit();
        },
        /* 赎回类型   0-普通赎回 1-快速赎回 */
        "fundInfo.sell"(val) {
            if (val === "1") {
                this.isPwdCheck = this.$cache.getPwdCheck("98");
                this.$set(this.fundInfo, "sellTo", "2");
                this.protocolArr = this.quickSellFiles;
            } else {
                this.protocolArr = this.sellFiles;
                this.isPwdCheck = this.$cache.getPwdCheck("24");
            }
            this.queryFundlimit();
            if (this.fundInfo.amount) {
                this.$refs.fundInfo.validateField("amount");
            }
            if (val === "1" && this.protocolArr.length == 0) {
                this.$message.error(
                    `缺失快速赎回协议，请联系【${this.$cache.getCompanyInfoParam("10101009")}】`
                );
            }
        },
        "fundInfo.sharetype"(val) {
            if (val === "1") {
                this.feeGate = {};
            }
        },
        "fundInfo.sellTo"(val) {
            if (val === "1") {
                // 钱柜只支持普通赎回
                this.$set(this.fundInfo, "sell", "0");
                this.$set(this.fundInfo, "largeredemptionflag", "0");
                // 处理赎回到现金宝选中第一条
                let arr = this.fund.fundArr.filter((item) => item.sellmode.includes("1"));
                if (arr.length > 0) {
                    this.$set(this.fundInfo, "id", arr[0].transactionaccountid + arr[0].index);
                }
            }
            this.getLimit();
            if (this.fundInfo.amount) {
                this.$refs.fundInfo.validateField("amount");
                this.queryRate();
            }
        },
        "fundInfo.amount"(val) {
            this.isAmount(val);
        }
    },
    async mounted() {
        this.commonQuestion = this.$const.commonQuestion.commonQuestion10;
        this.fund = JSON.parse(sessionStorage.getItem(this.$route.name));
        const urlTemplate = this.$cache.getCompanyInfoParam("10102031");
        // eslint-disable-next-line no-template-curly-in-string
        this.linkUrl = urlTemplate.replaceAll("${fundcode}", this.fund.fundcode);
        if (this.fund.fundArr.length > 0) {
            this.calculateTotal();
            this.fund.fundArr = this.fund.fundArr.filter((item) => {
                return item.sourceflag === "1" && item.usableremainshare > 0;
            });
            // 当没有符合赎回现金宝的账号 此选项直接隐藏
            let arr = this.fund.fundArr.filter(
                (item) => item.sellmode.includes("1") && item.redeemflag !== "0"
            );
            if (arr.length) {
                this.xjbSellflag = true;
            } else {
                this.xjbSellflag = false;
                this.$set(this.fundInfo, "sellTo", "2");
            }

            // let fundArr = Object.assign([], this.fund.fundArr);
            // let zx = [];
            // this.fund.fundArr = this.fund.fundArr.filter(
            //     (fund) =>
            //         fund.paycenterid !== this.$util.getConfig().const.ZX_CENTER &&
            //         fund.paycenterid !== "0001"
            // );
            // zx = fundArr.filter(
            //     (fund) =>
            //         fund.paycenterid === this.$util.getConfig().const.ZX_CENTER ||
            //         fund.paycenterid === "0001"
            // );
            // zx.forEach((item) => this.fund.fundArr.push(item));
        }
        this.isPwdCheck = this.$cache.getPwdCheck(this.fund.way);
        // 查询现金宝信息
        this.cfgFundrealtimeQueryAll();
        this.getSellInfo();
        // 查中港互认基金标识
        fundApi
            .getFundLists({
                keyword: this.fund.fundcode,
                pagesize: 20,
                pagenum: 1
            })
            .then((res) => {
                if (res.data) {
                    const list = res.data.list;
                    this.mrfflag = list.length > 0 && list[0].mrfflag === "1";
                    if (this.mrfflag) {
                        this.$nextTick(() => {
                            this.$set(this.fundInfo, "sellTo", "2");
                        });
                    }
                    if (list.length > 0 && list[0].ext) {
                        try {
                            const extData = JSON.parse(list[0].ext.replace(/\n/g, "\\n"));
                            const extraItem = extData.find(
                                (item) => item.definition === "附加管理费说明"
                            );
                            if (extraItem) {
                                this.postChargeDescribe = extraItem.content;
                            }
                        } catch (error) {
                            console.error("解析失败:", error);
                        }
                    }
                }
            });
        this.$cache.getCompanyInfoParam("10102033") &&
            this.isInTimeRange(
                this.$cache.getCompanyInfoParam("10102033"),
                format(new Date(), "YYYYMMDDhhmmss")
            );

        this.getAgreement(); // 获取快速赎回协议
        // 查询赎回费率信息
        this.getFundFeeRate();
    },
    methods: {
        async getAgreement() {
            const riskFileList = await this.$util.queryAgreementFile({
                scene: sceneEnum.sell,
                fundshowtype: this.fund.showtype
            });
            this.sellFiles = riskFileList;
            this.protocolArr = this.sellFiles;
            this.fund.fundshowtype == "5" &&
                this.$util.getProtocol(sceneEnum.quickSell, this.fund.fundshowtype).then((res) => {
                    if (res && res.length > 0) {
                        this.quickSellFiles = res;
                    }
                });
        },
        isInTimeRange(timeRange, currentTime) {
            const [start, end] = timeRange.split(",");
            this.tradeRestrictionsShow = currentTime >= start && currentTime <= end;
            return currentTime >= start && currentTime <= end;
        },
        // 获取限额
        getLimit() {
            let _max = null;
            let _min = null;
            if (this.fundInfo.sell === "0") {
                // 普通赎回
                if (this.fundInfo.sellTo === "1") {
                    // 钱柜
                    _max =
                        Number(this.bankInfo.usableremainshare) > Number(this.redeemInfo.xjbmax)
                            ? this.redeemInfo.xjbmax
                            : this.bankInfo.usableremainshare;
                    _min = this.redeemInfo.xjbmin;
                } else {
                    // 银行卡
                    _max =
                        Number(this.bankInfo.usableremainshare) >
                        Number(this.fastRedeemData.maxfastredeem)
                            ? this.fastRedeemData.maxfastredeem
                            : this.bankInfo.usableremainshare;
                    _min = this.fastRedeemData.minamount;
                }
            } else {
                // 快速赎回
                _max =
                    Number(this.bankInfo.usableremainshare) >
                    Number(this.fastRedeemData.maxfastredeem)
                        ? this.fastRedeemData.maxfastredeem
                        : this.bankInfo.usableremainshare;
                _min = this.fastRedeemData.minamount;
            }
            if (this.$util.isEmpty(_max)) {
                // 没返回最大限额，最大值为可用份额
                _max = this.bankInfo.usableremainshare;
            }
            this.$set(this.limit, "min", _min);
            this.$set(this.limit, "max", _max);
            this.pla =
                Number(_min) < Number(_max)
                    ? "本次可赎回" + this.$util.fmtNum(_min) + "-" + this.$util.fmtNum(_max) + "份"
                    : "本次只可全部赎回剩余份额";
        },

        // 查询现金宝信息
        async cfgFundrealtimeQueryAll() {
            let xjbFundInfo = JSON.parse(sessionStorage.getItem("xjbFundInfo"));
            this.xjbfundcode = xjbFundInfo.fundcode;
            if (!this.xjbfundcode || this.xjbfundcode === this.fund.fundcode) {
                this.$set(this.fundInfo, "sellTo", "2");
                return;
            }
            this.growthrate = xjbFundInfo.growthrate;
            // 赎回转购限额查询
            const res2 = await fundApi.combTransRedeemForBuyLimit({
                fundcode: this.fund.fundcode,
                sharetype: this.fund.sharetype,
                targetfundcode: this.xjbfundcode
            });
            this.hasxjb = res2.data && res2.data.datalist && res2.data.datalist.length > 0;
            this.$set(
                this.fundInfo,
                "sellTo",
                this.hasxjb && !this.mrfflag && this.xjbSellflag ? "1" : "2"
            );
            this.redeemInfo.xjbmin =
                res2.data &&
                res2.data.datalist &&
                res2.data.datalist[0] &&
                res2.data.datalist[0].min
                    ? res2.data.datalist[0].min
                    : 0;
            this.redeemInfo.xjbmax =
                res2.data &&
                res2.data.datalist &&
                res2.data.datalist[0] &&
                res2.data.datalist[0].max
                    ? res2.data.datalist[0].max
                    : 0;
            // 兜底 当现金宝模块没开默认勾选银行卡
            if (!this.$util.xjbIsOpen()) {
                this.$set(this.fundInfo, "sellTo", "2");
            }
            // 兜底 当赎回到现金宝功能未开通默认勾选银行卡
            if (!this.$util.sellToXjbOpen()) {
                this.$set(this.fundInfo, "sellTo", "2");
            }
            if (this.isOffline) {
                this.$set(this.fundInfo, "sellTo", "2");
            }
        },
        async queryFundlimit() {
            let res = await fundApi.combQueryFundlimit({
                fundcode: this.fund.fundcode,
                transactionaccountid: this.bankInfo.transactionaccountid,
                bankcode: this.bankInfo.bankcode,
                sharetype: this.bankInfo.sharetype,
                businesscode: this.fundInfo.sell === "0" ? "024" : "098",
                invtp: "1",
                transflag: "1"
            });
            this.fastRedeemData = res.data || {};
            this.getLimit();
        },
        /* 提交表单数据，校验用户信息 */
        submitInfo(formName) {
            if (
                Number(this.bankInfo.usableremainshare) - Number(this.fundInfo.amount) <
                    Number(this.redeemInfo.minaccountbalance) &&
                Number(this.fundInfo.amount) !== Number(this.bankInfo.usableremainshare)
            ) {
                this.$alert(
                    `最低可持有份额低于${this.redeemInfo.minaccountbalance}份，建议全部卖出`,
                    "温馨提示"
                );
                return;
            }
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    if (this.fundInfo.sellTo === "1") {
                        // TODO 赎回至现金宝 暂不支持
                        // 开了购买前校验开关才用
                        if (this.$util.buyVerificationOpen()) {
                            this.$util.checkComplianceService(this.xjbfundcode).then((checkRes) => {
                                if (checkRes.dialogType) {
                                    this.dialogButtonText = checkRes.dialogButtonText;
                                    this.dialogType = checkRes.dialogType;
                                    this.dialogContent = checkRes.dialogContent;
                                    this.buyRiskdialogVisible = true;
                                } else {
                                    this.$util.getSdxProtocol(
                                        {
                                            fundcode: this.xjbfundcode,
                                            fundshowtype: this.fund.fundshowtype,
                                            proto: "sell"
                                        },
                                        (res) => {
                                            this.xjbFundRisk = res;
                                            this.protocol = true;
                                        }
                                    );
                                }
                            });
                        } else {
                            this.$util.getSdxProtocol(
                                {
                                    fundcode: this.xjbfundcode,
                                    fundshowtype: this.fund.fundshowtype,
                                    proto: "sell"
                                },
                                (res) => {
                                    this.xjbFundRisk = res;
                                    this.protocol = true;
                                }
                            );
                        }
                    } else {
                        this.sellFund(true);
                    }
                } else {
                    this.$errorScroll();
                }
            });
        },
        async sellFund(val) {
            this.protocol = false;
            if (!val) return;
            let params = {
                fundcode: this.fund.fundcode,
                sharetype: this.fund.sharetype,
                transactionaccountid: this.bankInfo.transactionaccountid,
                applicationvol: this.fundInfo.amount, // 输入框内的份额
                largeredemptionflag: this.fundInfo.largeredemptionflag, // 巨额赎回标志   字典：110051 0-放弃超额部分 1-继续赎回
                tradepassword: this.$util.enc(this.fundInfo.pwd)
            };
            if (this.fundInfo.sellTo === "1") {
                // 钱柜
                params = Object.assign({}, params, {
                    targetfundcode: this.xjbfundcode,
                    redeemmode: "4",
                    buyflag: this.xjbFundRisk.riskmismatchflag == "1" ? "1" : "2",
                    riskwarnflag: this.xjbFundRisk.riskwarnflag == "1" ? "1" : "2",
                    highriskwarnflag: this.xjbFundRisk.highriskwarnflag == "1" ? "1" : "2"
                });
                // 如果是预约赎回转购，redeemmode传3
                if (this.fund.redeemflag == "0") {
                    params.enddate = this.fund.enddate;
                    params.redeemmode = "3";
                }
                if (this.dialogType == "warn") {
                    params.oldercustriskflag = "1";
                }
            } else {
                // 银行卡
                params = Object.assign({}, params, {
                    selltype: this.fundInfo.sell, // 赎回类型   0-普通赎回 1-快速赎回
                    referid: "", // 推荐人代码
                    referralname: "" // 推荐人姓名
                });
                // 如果是预约赎回，增加预约赎回日期入参
                if (this.fund.redeemflag == "0") {
                    params.enddate = this.fund.enddate;
                }
            }
            if (this.fundInfo.sell == "1") {
                this.tracesLog(this.protocolArr);
            }
            let rs = await fundApi[
                this.fundInfo.sellTo === "1" ? "combTransRedeemForBuy" : "redeemAsset"
            ](params);
            if (rs.error) return;
            if (rs.data) {
                this.result.cla = "register-success";
                if (this.fundInfo.sell === "0") {
                    this.result.btnMsg =
                        "预计确认时间：" +
                        this.$util.fmtDate(rs.data.transactioncfmdate) +
                        "， 如遇节假日则顺延，请耐心等待";
                } else {
                    this.result.btnMsg = "预计确认时间：两小时内到账，请耐心等待";
                }
            } else {
                this.result.cla = "register-fail";
                this.result.btnMsg = "原因：" + rs.msg;
            }
            this.result.msg =
                "您的赎回申请已受理" + (this.result.cla === "register-fail" ? "失败" : "成功");
            this.buySuccess = true;
        },
        // 同意快速赎回协议
        signAgreement() {
            if (this.fundInfo.sell == "1") {
                if (this.checkbox) {
                    return true;
                }
                let protocol = "";
                this.protocolArr.forEach((item) => {
                    protocol += `《${item.title}》`;
                });
                this.$confirm(`您还没有签署${protocol}，是否同意签署？`, {
                    confirmButtonText: "同意",
                    cancelButtonText: "不同意",
                    type: "warning"
                }).then(() => {
                    this.tracesLog(protocol);
                    this.checkbox = true;
                    return true;
                });
            } else {
                return true;
            }
        },
        // 留痕同意快速赎回协议
        tracesLog(protocol) {
            commonApi.commonLeaveTracesLog(this, {
                eventid: this.$const.RECORD.quick_redemption_agreement,
                eventname: `同意快速赎回协议`,
                content: JSON.stringify({ name: protocol })
            });
        },
        // 全部取现处理
        allSell() {
            this.fundInfo.amount = Number(this.bankInfo.usableremainshare) + "";
            this.$refs.fundInfo.validateField("amount");
            this.isAmountAll = true;
        },
        // 处理金额
        isAmount(val) {
            const _val = this.$util.checkAmount(val);
            clearTimeout(this.query);
            this.$set(this.fundInfo, "amount", _val);

            if (Number(this.fundInfo.amount) === this.bankInfo.usableremainshare) {
                this.isAmountAll = true;
            } else {
                this.isAmountAll = false;
            }
            this.query = setTimeout(() => {
                this.queryRate();
            }, 500);
        },
        async getFundFeeRate() {
            let rs = await fundApi.qryFundFeeService({
                fundcode: this.fund.fundcode,
                feetype: "3", // 赎回费率
                invtp: "1",
                sharetype: this.fund.sharetype,
                discountedRateflag: "1"
            });
            if (rs.error) {
                return;
            }

            const list = rs.data;
            if (list.length > 0 && list[0].interval == " ") {
                this.fundFeeRate = [
                    {
                        interval: "固定费用",
                        feeRate: list[0].feerate
                    }
                ];
            } else {
                this.fundFeeRate = list.map((item) => {
                    return {
                        ...item,
                        value: this.extractNumber(item.feerate || "")
                    };
                });
            }

            // 查回的基金赎回费率为多条数据时，展示区间；否则直接展示执行费率即可
            if (this.fundFeeRate.length > 1) {
                const max = this.fundFeeRate.reduce((pre, cur) => {
                    return pre["value"] > cur["value"] ? pre : cur;
                });

                const min = this.fundFeeRate.reduce((pre, cur) => {
                    return pre["value"] < cur["value"] ? pre : cur;
                });

                this.rateMax = max["feerate"];
                this.rateMin = min["feerate"];
            }
        },
        extractNumber(str) {
            // 使用正则表达式匹配数字（包括整数、小数、正负号）
            const match = str.match(/-?\d+(\.\d+)?/);
            if (!match) {
                return null; // 没有找到有效的数字
            }
            // 提取数字部分并转换为数值
            let number = parseFloat(match[0]);
            // 检查是否包含百分号，如果有则除以100
            if (str.includes("%")) {
                number /= 100;
            }
            return number;
        },
        // 费率入参获取
        async queryRate() {
            // 预约赎回和预约赎回转购不查手续费
            if (this.fund.redeemflag == "0") {
                return;
            }
            if (!Number(this.fundInfo.amount)) {
                this.feeGate = {};
                return;
            }
            this.$util.getFee(
                {
                    transactionaccountid: this.bankInfo.transactionaccountid,
                    fundcode: this.fund.fundcode,
                    sharetype: this.fund.sharetype,
                    businesscode: "24",
                    // paymode: "2",
                    applicationvol: this.fundInfo.amount,
                    channelid: this.fundInfo.channelid
                },
                (res) => {
                    this.feeGate = res;
                }
            );
        },
        amountLimit(rule, value, callback) {
            if (value === this.bankInfo.usableremainshare) {
                return callback();
            }
            rule.mes = "赎回份额";
            this.$util.validateAmountLimit(this, rule, value, callback);
        },
        // 赎回前数据查询
        async getSellInfo() {
            let rs = await fundApi.qryBeforeRedeem({
                fundcode: this.fund.fundcode,
                sharetype: this.fund.sharetype
            });
            if (rs.error) {
                return;
            }
            this.redeemInfo = rs.data;
            this.$set(
                this.fundInfo,
                "id",
                this.fund.fundArr[0].transactionaccountid + this.fund.fundArr[0].index
            );
            this.isOffline =
                this.fund.fundArr[0].paycenterid === this.$util.getConfig().const.ZX_CENTER ||
                this.fund.fundArr[0].paycenterid === "0001";
            if (this.fund.sharetype != "2") {
                this.$set(this.fundInfo, "sharetype", this.fund.sharetype);
            }
        },
        // 处理弹窗确认事件（按钮点击）
        handleDialogConfirm() {
            commonApi.commonLeaveTracesLog(this, {
                eventid: this.$const.RECORD.before_purchasing_verification,
                eventname: `购买前校验确定按钮`,
                content: JSON.stringify(
                    Object.assign({
                        name: "高龄客户",
                        dialogContent: this.dialogContent,
                        dialogButtonText: this.dialogButtonText
                    })
                )
            });
            // 根据弹窗类型执行不同操作
            if (this.dialogType === "warn") {
                this.$util.getSdxProtocol(
                    {
                        fundcode: this.xjbfundcode,
                        fundshowtype: this.fund.fundshowtype,
                        proto: "sell"
                    },
                    (res) => {
                        this.xjbFundRisk = res;
                        // this.protocol = true;
                        this.sellFund(true);
                    }
                );
            }
        },
        // 跳转到资产详情页
        showDetail() {
            this.$router.push("/assetsDetail");
        },
        // 计算总份额
        calculateTotal() {
            // 使用 reduce 方法安全计算总和
            this.sourceflagAllotment = this.fund.fundArr
                .filter((item) => {
                    return item.sourceflag === "2";
                })
                .reduce((sum, item) => {
                    // 确保值存在且为数字类型
                    const value = parseFloat(item.usableremainshare) || 0;
                    return sum + value;
                }, 0);
        },
        goToTradeRecord() {
            if (this.fund.way == "25") {
                this.$router.push({
                    name: "traderecord",
                    query: { activeType: "redemptionRecord" }
                });
            } else {
                this.$router.push({ name: "traderecord" });
            }
        }
    }
};
</script>
<style lang="scss" scoped>
.add-administration {
}
@import "../../assets/css/varibles";

.bizcomp-sell-fund {
    padding-bottom: 30px;
}
.common-question-contain {
    margin-top: 41px;
    padding: 0 20px;
}
.bank-img-sel {
    width: 550px !important;
}

.center {
    text-align: center;
}
</style>

<style lang="scss" scope>
.sourceflag-tip {
    display: flex;
    align-items: center;
    .allotment {
        color: var(--color-primary);
    }
    .toDetails {
        cursor: pointer;
        color: var(--color-redirect);
    }
}

.text-gray {
    color: var(--color-text-regular);
    font-weight: 400;
    font-size: 14px;
}

.text-desc {
    color: var(--color-text-accent);
    font-weight: 400;
    font-size: 12px;
    line-height: 16px;
}

.left-5 {
    margin-left: 5px;
}

.dialog-box {
    margin: 20px 0;
    padding: 0 45px;
    display: flex;
    flex-direction: column;
    color: var(--color-text-primary);

    .rate-table {
        color: var(--color-text-primary);
        margin-top: 12px;
    }
    .btn {
        margin-top: 18px;
        width: 160px;
        height: 42px;
        background: var(--color-primary);
        font-size: 16px;
        color: var(--color-text-white);
    }
}
</style>
